export default __webpack_public_path__ + "static/media/eduImgBlack.b19a68ba.svg";